import {
  FormatListBulletedIcon,
  ArticleIcon,
  AzmoonTashrihiIcon,
  AzmoonTestiIcon,
  DarsnamehIcon,
  RoznegarIcon,
  TakTestIcon,
  TaklifIcon,
  VoteIcon,
  WFormIcon,
  WPostIcon,
  SupportIcon,
  ChartArcIcon,
  NevisehWappIcon,
} from '@weblite/icons'
import { styled } from '@mui/material'
import {
  MeetingWappIcon,
  BlogWappIcon,
  EventWappIcon,
  RahkarWappIcon,
  DiscussionWappIcon,
  TribuneWappIcon,
} from '$common/icons/wapps'
import { LocationIcon } from '$common/icons/location'
import { getWappIcon } from '$logic/wapps/wapps.helper'
import { wappByIdView } from '$logic/wapps/wapps.reducer'
import { t } from '$i18n'

export const POLL_CONFIG = {
  name: t('wapps.poll'),
  color: 'neutral000',
  icon: (
    <VoteIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #FFF35F 0%, #FFB100 100%)',
}

export const POST_CONFIG = {
  name: t('wapps.post'),
  color: 'neutral000',
  icon: (
    <WPostIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #909090 0%, #262626 100%)',
}

export const KAGHAZ_CONFIG = {
  name: t('wapps.kaghaz'),
  color: 'neutral000',
  icon: (
    <WPostIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #909090 0%, #262626 100%)',
}

export const FORM_CONFIG = {
  name: t('wapps.form'),
  color: 'neutral000',
  icon: (
    <WFormIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #1DCBB0 0%, #008D77 100%)',
}

export const MULTIPLE_CHOICE_EXAM_CONFIG = {
  name: t('wapps.multipleChoiceExam'),
  color: 'neutral000',
  icon: (
    <AzmoonTestiIcon
      sx={{ color: 'neutral000', width: '100%', height: '100%' }}
    />
  ),
  loadingGradient: 'linear-gradient(180deg, #FF7676 0%, #D10000 100%)',
}

export const DESCRIPTIVE_EXAM_CONFIG = {
  name: t('wapps.descriptiveExam'),
  color: 'neutral000',
  icon: (
    <AzmoonTashrihiIcon
      sx={{ color: 'neutral000', width: '100%', height: '100%' }}
    />
  ),
  loadingGradient: 'linear-gradient(180deg, #FF7676 0%, #D10000 100%)',
}

export const UNIT_TEST_CONFIG = {
  name: t('wapps.unitTest'),
  color: 'neutral000',
  icon: (
    <TakTestIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #00BAFF 0%, #093DEB 100%)',
}
export const HOMEWORK_CONFIG = {
  name: t('wapps.homework'),
  color: 'neutral000',
  icon: (
    <TaklifIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #FF7600 0%, #E00000 100%)',
}

export const DARSNAMEH_CONFIG = {
  name: t('wapps.darsnameh'),
  color: 'neutral000',
  icon: (
    <DarsnamehIcon
      sx={{ color: 'neutral000', width: '100%', height: '100%' }}
    />
  ),
  loadingGradient: 'linear-gradient(180deg, #3444FF 0%, #0E1781 100%)',
}

export const ARTICLE_CONFIG = {
  name: t('wapps.article'),
  color: 'neutral000',
  icon: (
    <ArticleIcon sx={{ color: 'neutral000', width: '65%', height: '65%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #8E6788 0%, #42275A 100%)',
}

export const SUPPORT_CONFIG = {
  name: t('myAccount.support'),
  color: 'neutral000',
  icon: (
    <SupportIcon sx={{ color: 'neutral000', width: '65%', height: '65%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
}

export const STUDENT_SUPPORT_CONFIG = {
  name: t('myAccount.support'),
  color: 'neutral000',
  icon: (
    <SupportIcon sx={{ color: 'neutral000', width: '65%', height: '65%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
}

export const ROOZNEGAR_CONFIG = {
  name: t('wapps.rooznegar'),
  color: 'neutral000',
  icon: (
    <RoznegarIcon sx={{ color: 'neutral000', width: '100%', height: '100%' }} />
  ),
  loadingGradient: 'linear-gradient(180deg, #1DCB4E 0%, #008D28 100%)',
}

// TODO: Remove these configs and their usage

export const MEETING_CONFIG = {
  name: t('wapps.meeting'),
  color: '#52BD67',
  icon: <MeetingWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%);',
}

export const FORUM_CONFIG = {
  name: t('wapps.forum'),
  color: '#52BD67',
  icon: <DiscussionWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #96C93D 0%, #00B09B 100.48%)',
}

export const RAHKAR_CONFIG = {
  name: t('wapps.rahkar'),
  color: '#52BD67',
  icon: <RahkarWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #96C93D 0%, #00B09B 100.48%)',
}

export const BLOG_CONFIG = {
  name: t('wapps.blog'),
  color: '#F75B5C',
  icon: <BlogWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
}

export const NEVISEH_CONFIG = {
  name: t('wapps.nevise'),
  color: '#F75B5C',
  icon: <NevisehWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
}

export const USAGE_DASHBOARD_CONFIG = {
  name: t('wapps.usageDashboard'),
  color: '#6B54F7',
  icon: <ChartArcIcon />,
  loadingGradient: 'linear-gradient(267.61deg, #7841E7 0%, #38A9E1 99.81%)',
}

export const EVENT_CONFIG = {
  name: t('wapps.event'),
  color: '#52BD67',
  icon: <EventWappIcon />,
  loadingGradient: 'linear-gradient(147.25deg, #00B09B 0.82%, #96C93D 100.82%)',
}

export const MULTIMEDIA_CONFIG = {
  name: t('wapps.multimedia'),
  color: '#5C64ED',
  icon: <RahkarWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #9445EC 0%, #2782ED 100%)',
}

export const TRIBUNE_CONFIG = {
  name: t('wapps.tribune'),
  color: '#52BD67',
  icon: <TribuneWappIcon />,
  loadingGradient: 'linear-gradient(180deg, #00B09B 0%, #96C93D 100.48%)',
}

export const MAP_CONFIG = {
  name: t('wapps.map'),
  color: 'primary.main',
  icon: <LocationIcon sxProps={{ color: 'primary.main' }} />,
  loadingGradient: '',
}

export const PORSESH_CONFIG = {
  name: t('wapps.porsesh'),
  color: 'primary.main',
  icon: <FormatListBulletedIcon />,
  loadingGradient: 'linear-gradient(0deg, #0538FF 0%, #70E3F5 100%)',
}

export const RECEIPTS_ADMIN_PANEL_CONFIG = {
  name: t('wapps.receiptsAdminPanel'),
  color: '#F75B5C',
  icon: <NevisehWappIcon />,
  loadingGradient: 'linear-gradient(60deg, #F57073 13.4%, #FA4545 86.6%)',
}

const WAPP_BAR_THEME: Record<
  string, //  WappGroupName
  { name: string; color: string; icon: JSX.Element; loadingGradient: string }
> = {
  postlite: POST_CONFIG,
  post: POST_CONFIG,
  kaghaz: KAGHAZ_CONFIG,
  votelite: POLL_CONFIG,
  poll: POLL_CONFIG,
  form: FORM_CONFIG,
  'general-exam': MULTIPLE_CHOICE_EXAM_CONFIG,
  'general-descriptive-exam': DESCRIPTIVE_EXAM_CONFIG,
  'tak-test': UNIT_TEST_CONFIG,
  darsnameh: DARSNAMEH_CONFIG,
  homework: HOMEWORK_CONFIG,
  rooznegar: ROOZNEGAR_CONFIG,
  article: ARTICLE_CONFIG,
  support: SUPPORT_CONFIG,
  studentSupport: STUDENT_SUPPORT_CONFIG,

  meeting: MEETING_CONFIG,
  blog: BLOG_CONFIG,
  forum: FORUM_CONFIG,
  event: EVENT_CONFIG,
  multimedia: MULTIMEDIA_CONFIG,
  tribune: TRIBUNE_CONFIG,
  map: MAP_CONFIG,
  neviseh: NEVISEH_CONFIG,
  'usage-dashboard': USAGE_DASHBOARD_CONFIG,
  porsesh: PORSESH_CONFIG,

  honarioon: RECEIPTS_ADMIN_PANEL_CONFIG,
}

const WappIconImage = styled('img')`
  width: inherit;
  height: inherit;
`

export function getWappTheme(wappId: string) {
  const { groupName } = wappByIdView(wappId) || {}

  return (
    (groupName && WAPP_BAR_THEME[groupName]) || {
      name: groupName ?? (t('wapps.unknown') as string),
      color: '#818181',
      icon: groupName ? (
        <WappIconImage src={getWappIcon(wappId)} alt="Wapp Icon" />
      ) : (
        (null as unknown as JSX.Element)
      ),
      loadingGradient: 'unset',
    }
  )
}
